/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/ 
 
import { useState, useEffect, useRef } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, TextField, Button, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, OutlinedInput, FormControl, Typography} from "@mui/material";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// Soft UI Dashboard React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import VendorInfoCard from "layouts/dashboard/components/ForProjects/OrderDetails/Cards/VendorInfoCard";
import CancelRequest from "layouts/dashboard/components/ForProjects/OrderDetails/CancelRequest/CancelRequest";
import StatusChangeDialog from "components/StatusChangeDialog";

//mui icons
import FireTruckIcon from "@mui/icons-material/FireTruck";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import CloudIcon from "@mui/icons-material/Cloud";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TitleIcon from "@mui/icons-material/Title";
import DescriptionIcon from "@mui/icons-material/Description";
import BusinessIcon from "@mui/icons-material/Business";
import DistanceIcon from "@mui/icons-material/Explore"
import WorkIcon from "@mui/icons-material/Work";
import EventIcon from "@mui/icons-material/Event";
import VerifiedIcon from "@mui/icons-material/Verified"; // Status Icon
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import DownloadIcon from "@mui/icons-material/Download";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import PhoneIcon from "@mui/icons-material/Phone";
//pictogrammers icons

// Soft UI Dashboard React icons
import Cube from "examples/Icons/Cube";
import Document from "examples/Icons/Document";
import Settings from "examples/Icons/Settings";

// Soft UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
import home from "assets/images/home.jpg";
import homeimage from "assets/images/h2.jpg";
import curved0 from "assets/images/curved-images/curved0.jpg";
import MyGoogleMap from "layouts/dashboard/components/ForProjects/OrderDetails/GoogleMap";
import { object } from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import ProjectAccordion from "layouts/profile/components/ProjectAccordion/ProjectAccordion";
import EditProjectAccordion from "layouts/profile/components/ProjectAccordion/EditProjectAccordion";
import borders from "assets/theme/base/borders";
import boxShadow from "assets/theme/functions/boxShadow";
import typography from "assets/theme/base/typography";
import SoftButton from "components/SoftButton";
import EditIcon from "@mui/icons-material/Edit";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CloseIcon from "@mui/icons-material/Close";
import { Check } from "@mui/icons-material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { 
  getOrderById, 
  updateOrderTotal, 
  fetchStatusList, 
  fetchVendorList, 
  changeVendor, 
  getEmailTemplate,
  editEmailTemplate,
  sendManualEmail,
  changeStatusWithoutEmail,
  getOrderPriceAnalysis,
} from "api/apiService";
import ReactQuill from 'react-quill-new';
import CircularProgress from "@mui/material/CircularProgress"; // Importing CircularProgress for loader

import { NavLink } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { notify, notifyCenter } from "utils/toast";


const emailTypes = [
  { value: "order_creation", full_name: "Order Creation" },
  { value: "status_change", full_name: "Status Change" },
  { value: "price_change_by_admin", full_name: "Price Change By Admin" },
  { value: "custom", full_name: "Custom" },
];

const roleIcons = {
  admin: <AdminPanelSettingsIcon />,
  vendor: <StorefrontIcon />,
  customer: <PeopleAltIcon />,
};


function EditDetail() {
  const [loading, setLoading] = useState(false);  // Loader state
  const location = useLocation();
  const { orderId } = useParams();
  // const orderId = location.state?.orderId;
  console.log("orderDetail page-----", orderId,);
  const [orderData, setOrderData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const { size, fontWeightBold } = typography;
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  const [isEditing, setIsEditing] = useState(false);
  const [orderTotal, setOrderTotal] = useState(orderData?.order_total || 0);
  const [tempOrderTotal, setTempOrderTotal] = useState(orderData?.order_total || 0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const selectRef = useRef(null);
  const [open2, setOpen2] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showListModal, setShowListModal] = useState(false);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedEmailType, setSelectedEmailType] = useState(""); // initially empty
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  console.log("selectedTemplate-----", selectedTemplate,);
  console.log("selectedEmailType-----", selectedEmailType,);

  const [formData, setFormData] = useState({
    email_type: "",
    status: "",
    template_name: "",
    subject: "",
    send_to: [],
    send_to_email: "",     // ✅ NEW (textarea value)
    send_to_emails: [],    // ✅ NEW (array to send)
    message: "",
  });

  const ADMIN_EMAIL = "post@betongsentrum.no";

  // ✅ UPDATED: split by comma/newline/space/semicolon and unique (case-insensitive)
  const extractEmailsFromText = (text = "") => {
    const parts = text
      .split(/[\n,; \t]+/g) // newline, comma, semicolon, spaces, tabs
      .map((s) => s.trim())
      .filter(Boolean);

    const uniq = new Map();
    parts.forEach((p) => {
      const key = p.toLowerCase();
      if (!uniq.has(key)) uniq.set(key, p);
    });

    return Array.from(uniq.values());
  };


  // ✅ NEW: auto emails from selected roles (from order detail)
  const getAutoEmails = (sendTo = []) => {
    const vendorEmail = (orderData?.vendor_email || "").trim();
    const customerEmail = (orderData?.email || orderData?.step3?.emailAddress || "").trim();

    const map = {
      admin: ADMIN_EMAIL,
      vendor: vendorEmail,
      customer: customerEmail,
    };

    const uniq = new Map();
    sendTo.forEach((r) => {
      const email = (map[r] || "").trim();
      if (!email) return;
      const key = email.toLowerCase();
      if (!uniq.has(key)) uniq.set(key, email);
    });

    return Array.from(uniq.values());
  };

  // ✅ NEW: modal open / orderData update par sirf "missing auto emails" add karega (typing overwrite nahi)
  useEffect(() => {
    if (!showListModal) return;

    const roles = formData?.send_to || [];
    if (roles.length === 0) return;

    const auto = getAutoEmails(roles).filter(Boolean);
    if (auto.length === 0) return;

    setFormData((prev) => {
      const currentList = extractEmailsFromText(prev.send_to_email || "");
      const currentSet = new Set(currentList.map((e) => e.toLowerCase()));

      let changed = false;
      auto.forEach((em) => {
        const key = em.toLowerCase();
        if (!currentSet.has(key)) {
          currentList.push(em);
          currentSet.add(key);
          changed = true;
        }
      });

      if (!changed) return prev;

      return {
        ...prev,
        send_to_email: currentList.join(",\n"),
      };
    });
  }, [
    showListModal,
    formData.send_to, // ✅ IMPORTANT: template load ke baad effect re-run hoga
    orderData?.vendor_email,
    orderData?.email,
    orderData?.step3?.emailAddress,
  ]);



  // ✅ UPDATED: typing ko bilkul touch nahi karega
  const handleSendToEmailChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      send_to_email: e.target.value,
    }));
  };

  // ✅ NEW: blur par clean + dedupe (optional but recommended)
  const handleSendToEmailBlur = () => {
    setFormData((prev) => ({
      ...prev,
      send_to_email: extractEmailsFromText(prev.send_to_email || "").join(",\n"),
    }));
  };


  // ✅ NEW: role toggle => send_to + send_to_email both update
  const handleToggleSendToRole = (roleKey) => {
    const isSelected = formData.send_to.includes(roleKey);

    const updatedList = isSelected
      ? formData.send_to.filter((r) => r !== roleKey)
      : [...formData.send_to, roleKey];

    const roleEmail = (() => {
      const vendorEmail = (orderData?.vendor_email || "").trim();
      const customerEmail = (orderData?.email || orderData?.step3?.emailAddress || "").trim();

      if (roleKey === "admin") return (ADMIN_EMAIL || "").trim();
      if (roleKey === "vendor") return vendorEmail;
      if (roleKey === "customer") return customerEmail;
      return "";
    })();

    setFormData((prev) => {
      let nextText = prev.send_to_email || "";

      // select => add email (if exists)
      if (!isSelected && roleEmail) {
        const list = extractEmailsFromText(nextText);
        const exists = list.some((e) => e.toLowerCase() === roleEmail.toLowerCase());
        if (!exists) list.push(roleEmail);
        nextText = list.join(",\n");
      }

      // unselect => remove email ONLY if not used by remaining selected roles
      if (isSelected && roleEmail) {
        const remainingRoles = updatedList;
        const stillNeeded = remainingRoles.some((r) => {
          const em =
            r === "admin"
              ? (ADMIN_EMAIL || "").trim()
              : r === "vendor"
              ? (orderData?.vendor_email || "").trim()
              : (orderData?.email || orderData?.step3?.emailAddress || "").trim();

          return em && em.toLowerCase() === roleEmail.toLowerCase();
        });

        if (!stillNeeded) {
          const list = extractEmailsFromText(nextText).filter(
            (e) => e.toLowerCase() !== roleEmail.toLowerCase()
          );
          nextText = list.join(",\n");
        }
      }

      return {
        ...prev,
        send_to: updatedList,
        send_to_email: nextText,
      };
    });
  };


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    fetchEmailTemplates();
  },[]);

  const fetchEmailTemplates = async () => {
    setIsLoadingTemplates(true);
    try {
      const response = await getEmailTemplate({ limit: -1, page_number: 1 });
      if (response.status) {
        setEmailTemplates(response.data); // adjust if nested inside response.data.templates
      } else {
        console.error("Feil ved henting av maler:", response.message);
      }
    } catch (error) {
      console.error("API-feil ved henting av maler:", error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  const handleEditTemplate = async (templateId) => {
    setIsLoadingTemplates(true);           // Show loading spinner in modal
    setShowListModal(true);
    try {
      const response = await editEmailTemplate(templateId);
      if (response.status) {
        setSelectedTemplate(response.data); // Store in state
        const t = response.data;

        setFormData({
          template_name: t.template_name,
          subject: t.subject,
          message: t.message,
          send_to: Array.isArray(t.send_to) ? t.send_to : [],
          send_to_email: "",   // ✅ auto-filled by useEffect
          send_to_emails: [],  // ✅ auto-filled by useEffect
        });

        setSelectedEmailType(t.email_type);
        // Statusen her endrer ordren, så den skal velges bevisst — ikke følge
        // med malen.
        setSelectedStatus('');
        setIsLoadingTemplates(false);
      } else {
        setShowListModal(false);
        setIsLoadingTemplates(false);
        console.error("Feil:", response.message);
      }
    } catch (error) {
      setShowListModal(false);
      setIsLoadingTemplates(false);
      console.error("API-feil ved lasting av mal:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };


  const handleInputClick4 = () => {
    setOpen4((prevOpen) => !prevOpen);
  };

  const handleInputClick5 = () => {
    setOpen5((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen5(false);
  };

  const handleDownloadPriceAnalysis = async () => {
    try {
      const res = await getOrderPriceAnalysis({ order_id: orderId });
      if (!res?.status) {
        notifyCenter("error", res?.message || "Kunne ikke hente prisanalyse", { duration: 3000 });
        return;
      }

      const pj = res?.data?.priceJson ?? res?.data?.priceJsonRaw;

      // make sure object
      let parsed;
      try {
        parsed = typeof pj === "string" ? JSON.parse(pj) : pj;
      } catch (e) {
        notifyCenter("error", "Ugyldig prisanalyse JSON", { duration: 3000 });
        return;
      }

      const text = buildPriceAnalysisReport(parsed, orderId);

      // download txt
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `order_analysis_${orderId}.txt`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
      notifyCenter("success", "Prisanalyse lastet ned", { duration: 2000 });
    } catch (err) {
      console.error("download price analysis error", err);
      notifyCenter("error", "Kunne ikke laste ned prisanalyse", { duration: 3000 });
    }
  };


  function buildPriceAnalysisReport(priceJson, orderId) {
    const out = [];
    const sep = (title) => out.push(`\n==================== ${title} ==============\n`);
    const line = (s = "") => out.push(s);

    const fmtNum = (v) => {
      const n = Number(v);
      if (!Number.isFinite(n)) return String(v ?? "");
      const isInt = Math.abs(n - Math.round(n)) < 1e-9;
      return isInt ? String(Math.round(n)) : n.toFixed(2);
    };

    const fmtInputVal = (v) => {
      if (v === null || v === undefined) return "NULL";
      if (typeof v === "string") return v;
      if (typeof v === "number" || typeof v === "boolean") return String(v);
      try {
        return JSON.stringify(v);
      } catch (e) {
        return String(v);
      }
    };

    // PHP-like Array print (similar to WP logs)
    const toPhpArrayLike = (value, indent = 0) => {
      const pad = "    ".repeat(indent);

      if (value === null || value === undefined) return `${pad}NULL`;

      if (Array.isArray(value)) {
        let s = `${pad}Array\n${pad}(\n`;
        value.forEach((v, i) => {
          const isObj = v && (typeof v === "object");
          if (isObj) {
            s += `${pad}    [${i}] => \n${toPhpArrayLike(v, indent + 2)}\n`;
          } else {
            s += `${pad}    [${i}] => ${fmtInputVal(v)}\n`;
          }
        });
        s += `${pad})`;
        return s;
      }

      if (typeof value === "object") {
        let s = `${pad}Array\n${pad}(\n`;
        Object.keys(value).forEach((k) => {
          const v = value[k];
          const isObj = v && (typeof v === "object");
          if (isObj) {
            s += `${pad}    [${k}] => \n${toPhpArrayLike(v, indent + 2)}\n`;
          } else {
            s += `${pad}    [${k}] => ${fmtInputVal(v)}\n`;
          }
        });
        s += `${pad})`;
        return s;
      }

      return `${pad}${fmtInputVal(value)}`;
    };

    const printKeyValues = (obj) => {
      if (!obj || typeof obj !== "object") return;
      Object.keys(obj).forEach((k) => {
        line(`${k}: ${fmtInputVal(obj[k])}`);
      });
    };

    const printMappedBlock = (obj, keyOrder, labelMap, totalKeyLabel) => {
      const used = new Set();

      keyOrder.forEach((k) => {
        if (obj && Object.prototype.hasOwnProperty.call(obj, k)) {
          used.add(k);
          const label = labelMap[k] || k;
          line(` ${label}: ${fmtNum(obj[k])}`);
        }
      });

      // Print remaining keys (so you always get FULL detail)
      if (obj && typeof obj === "object") {
        Object.keys(obj).forEach((k) => {
          if (used.has(k)) return;
          const label = labelMap[k] || k;
          line(` ${label}: ${fmtNum(obj[k])}`);
        });
      }

      // Optional total label at end if exists
      if (totalKeyLabel && obj && Object.prototype.hasOwnProperty.call(obj, "total")) {
        line(` ${totalKeyLabel}: ${fmtNum(obj.total)}`);
      }
    };

    // Header
    line("========================================");
    line(`PRICE ANALYSIS (Order #${orderId})`);
    line("========================================\n");

    const deliveries = priceJson?.deliveries || [];
    const inputs = priceJson?.inputs || [];
    const translationsArr = priceJson?.transportation || []; // WP calls it "Translations"
    const concreteArr = priceJson?.concrete || [];
    const extrasArr = priceJson?.extras || [];
    const priceBufferArr = priceJson?.priceBuffer || [];
    const verifyArr = priceJson?.test_n_verify || [];
    const priceListArr = priceJson?.priceList || [];
    const totals = priceJson?.totals || null;

    if (totals) {
      sep("Order Totals");
      line(`Subtotal: ${fmtNum(totals.subtotal)}`);
      line(`VAT Percent: ${fmtNum(totals.vatPercent)}`);
      line(`VAT Amount: ${fmtNum(totals.vatAmount)}`);
      line(`Grand Total: ${fmtNum(totals.grandTotal)}`);
    }

    const transportationLabelMap = {
      transportation: "Transpotation",
      transportation_volume_added: "Transpotation Volume",
      equipment_price: "Equipment",
      delivery_time_price: "Delivery Time",
      vehicle_price: "Vehicle Price",
      total: "Transpotation Total",
    };
    const transportationOrder = [
      "transportation",
      "transportation_volume_added",
      "equipment_price",
      "delivery_time_price",
      "vehicle_price",
      "total",
    ];

    const concreteLabelMap = {
      quality: "Quality",
      stone: "Stone",
      reduction: "Reduction",
      consistency: "Consistency",
      customLowCarbon: "Custom Low Carbon",
      customCurbstone: "Custom Curb Stone",
      customFrostProof: "Custom Frost Proof",
      customFarming: "Custom Farming",
      total: "Concrete Total",
    };
    const concreteOrder = [
      "quality",
      "stone",
      "reduction",
      "consistency",
      "customLowCarbon",
      "customCurbstone",
      "customFrostProof",
      "customFarming",
      "total",
    ];

    const extrasLabelMap = {
      total_hose: "Total Hose",
      extraPersonnel: "Extra Personnel",
      washerPrice: "Washer Price",
      pumploss: "Pumploss",
      winterFee: "Winter Fee",
      heatedConcrete: "Heated Concrete",
      decline: "Decline",
      retardation: "Retardation",
      retardation_value: "Retardation Value",
      steel_fiber: "Steel Fiber",
      steel_fiber_value: "Steel Fiber Value",
      accelerator: "Accelerator",
      accelerator_value: "Accelerator Value",
      total: "Total Exras",
    };
    const extrasOrder = [
      "total_hose",
      "extraPersonnel",
      "washerPrice",
      "pumploss",
      "winterFee",
      "heatedConcrete",
      "decline",
      "retardation",
      "retardation_value",
      "steel_fiber",
      "steel_fiber_value",
      "accelerator",
      "accelerator_value",
      "total",
    ];

    deliveries.forEach((d, i) => {
      line("\n\n============================================================\n");
      line(`Delivery ${i + 1} (deliveryId: ${d?.deliveryId ?? i + 1})`);
      line("\n============================================================\n");

      // 1) Inputs (WP style)
      sep("Create Mode");
      sep("Input Values");
      printKeyValues(inputs[i] || {});

      // 2) Translations / Concrete / Extras arrays (WP style)
      sep("Translations");
      line(toPhpArrayLike(translationsArr[i] || {}));

      sep("Concrete");
      line(toPhpArrayLike(concreteArr[i] || {}));

      sep("Extras");
      line(toPhpArrayLike(extrasArr[i] || {}));

      sep("Price Buffer");
      line(fmtNum(priceBufferArr[i] ?? ""));

      // 3) Test & Verify (WP style)
      sep("To Test & Verify");
      line(toPhpArrayLike(verifyArr[i] || {}));

      // 4) Price List (WP style readable blocks)
      sep("Price List");

      const pl = priceListArr[i] || {};
      const tObj = pl.transportation || d?._calc?.transportation || {};
      const cObj = pl.concrete || d?._calc?.concrete || {};
      const eObj = pl.extras || d?._calc?.extras || {};
      const finalObj = pl.finalPrice || d?._calc?.finalPrice || {};
      const ovObj = pl.orderValue || d?._calc?.orderValue || {};

      sep("Transpotation");
      printMappedBlock(tObj, transportationOrder, transportationLabelMap, "Transpotation Total");

      sep("Concrete");
      printMappedBlock(cObj, concreteOrder, concreteLabelMap, "Concrete Total");

      sep("Extras");
      printMappedBlock(eObj, extrasOrder, extrasLabelMap, "Total Exras");

      sep("Final Price");
      line(` Transpotation: ${fmtNum(finalObj.transportation ?? "")}`);
      line(` Concrete: ${fmtNum(finalObj.concrete ?? "")}`);
      line(` Extras: ${fmtNum(finalObj.extras ?? "")}`);
      line(` Price Buffer: ${fmtNum(finalObj.priceBuffer ?? "")}`);
      line(` Final Total: ${fmtNum(finalObj.finalTotal ?? "")}`);

      sep("Order Values");
      line(`Transpotation: ${fmtNum(ovObj.transportation ?? "")}`);
      line(`Concrete: ${fmtNum(ovObj.concrete ?? "")}`);
      line(`Extras: ${fmtNum(ovObj.extras ?? "")}`);
      line(`Price Buffer %: ${fmtNum(ovObj.priceBufferPercent ?? "")}`);
      line(`Price Buffer Value: ${fmtNum(ovObj.priceBuffer ?? "")}`);
      line(`Price: ${fmtNum(ovObj.price ?? "")}`);

      // Delivery price summary (like WP)
      line("\n ============================================================\n");
      line(` Delivery ${i + 1} Price: ${fmtNum(d?.price ?? ovObj.price ?? finalObj.finalTotal ?? "")}`);
      line("\n ============================================================\n");

      // Optional VAT info (you can remove if you don’t want it)
      line(` VAT %: ${fmtNum(d?.vatPercent ?? "")}`);
      line(` VAT Amount: ${fmtNum(d?.vatAmount ?? "")}`);
      line(` Total With VAT: ${fmtNum(d?.totalWithVat ?? "")}`);
    });

    return out.join("\n");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Build final data first
    const fullData = {
      ...formData,
      email_type: selectedEmailType,
      status: selectedStatus,
    };

    // ✅ Extract recipients from textarea text (still ok for UI input)
    const recipients = extractEmailsFromText(fullData.send_to_email);

    const missingFields = [];
    if (!fullData.email_type) missingFields.push("email_type");
    if (!fullData.template_name) missingFields.push("template_name");
    if (!fullData.subject) missingFields.push("subject");
    if (!fullData.message) missingFields.push("message");
    if (!fullData.send_to || fullData.send_to.length === 0) missingFields.push("send_to");

    // ✅ now validate ONLY array
    if (!recipients || recipients.length === 0) missingFields.push("send_to_emails");

    if (missingFields.length > 0) {
      console.log("❌ Missing fields:", missingFields);
      notifyCenter("warning", "Vennligst fyll ut alle obligatoriske felt.", { duration: 3000 });
      return;
    }

    // ✅ send only array
    fullData.send_to_emails = recipients;
    fullData.orderId = orderId;

    // ✅ remove string field from payload completely
    delete fullData.send_to_email;

    // console.log("📤 Email Template Data to Submit:", fullData);
    setIsLoading(true);

    try {
      const response = await sendManualEmail(fullData);
      console.log("✅ Email send successfully:", response);

      setIsLoading(false);

      if (response.status === true) {
        setShowListModal(false);
        setSelectedTemplate(null);
        // Valgfri statusendring sammen med e-posten, uten statusens egen mal
        // (se OrderDetail.js).
        const statusKey = orderData?.order_status_key || "";
        const newStatus = fullData.status;
        if (newStatus && newStatus !== statusKey) {
          const res = await changeStatusWithoutEmail(orderId, newStatus).catch(() => null);
          if (res?.ok === true) {
            notifyCenter("success", "E-posten ble sendt, og status er endret.", { duration: 3000 });
            fetchOrderDetails();
          } else {
            notifyCenter("warning", res?.message || "E-posten ble sendt, men statusen ble ikke endret.", { duration: 4000 });
          }
        } else {
          notifyCenter("success", "E-posten ble sendt manuelt.", { duration: 3000 });
        }
      } else {
        setShowListModal(true);
        notifyCenter("error", response.msg || "Det oppstod en feil under sending av e-posten.", { duration: 3000 });
      }
    } catch (error) {
      setShowListModal(true);
      console.error("❌ Error sending email:", error);
      notifyCenter("error", "Det oppstod en feil under sending av e-posten.", { duration: 3000 });
      setIsLoading(false);
    }
  };

  const handleEditClick = () => {
    const numericOrderTotal = parseFloat(orderData?.order_meta?._order_total[0] || 0);
    setTempOrderTotal(numericOrderTotal);
    setIsModalOpen(true);
  };

  // Open the modal
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

// Close the modal
const handleCloseModal = () => {
  setIsModalOpen(false);
};

const handleInputClick2 = () => {
  setOpen2((prevOpen) => !prevOpen);
};

// Save the updated order total
const handleSaveClick = async () => {
  setLoading(true); // Show loader
  console.log("Saved Order Total: ", tempOrderTotal); // Log the input value when saving

  // Call the API function to update the order total
  try {
    const response = await updateOrderTotal(orderId, tempOrderTotal);
    if (response.ok === true) {
      console.log("Order total updated successfully:", response.message);

      // Update the order data with the new total
      setOrderData((prevData) => ({
        ...prevData,
        new_total: tempOrderTotal,
      }));

      notifyCenter("success", "Bestillingens totalbeløp oppdatert vellykket!", { duration: 2000 });
      setIsModalOpen(false); // Close modal
      setIsEditing(false); // Exit edit mode
      setLoading(false); // Stop loader

      // Optionally, reload the page after 2 seconds to reflect changes
      setTimeout(() => {
        window.location.reload(); // Reload the page after success message
      }, 1000);
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    setLoading(false); // Stop loader
    notifyCenter("error", "Feil ved oppdatering av bestillingens totalbeløp.", { duration: 3000 });
    console.error("Error updating order total:", error);
  }
};

// Cancel editing 
const handleCancelClick = () => {
  setTempOrderTotal(orderData?.new_total); // Reset tempOrderTotal
  setIsEditing(false); // Exit edit mode
  setIsModalOpen(false); // Close modal
};


  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  // const dataSet = { weather_temprature: 4, weather_icon: "url", address: "address" };

  const role = localStorage.getItem("role");

   // Define the onSave function
  const handleSave = (savedData) => {
    console.log("Data saved:", savedData);
    // You can send this data to an API or handle it as needed.
  };
  

  const fetchOrderDetails = async () => {
    const data = await getOrderById({ order_id: orderId });

    if (data.status) {
      setOrderData(data.data);
      setIsLoading(false);

      console.log("set data", orderData, data.data);
    }

    console.log("fetch order by id: ", data);
  };

  const fetchVendors = async () => {
    try {
      const response = await fetchVendorList();
      console.log(" fetching Vendors", response);
      if (response.status) {
        setVendorList(response.vendor_list);
      }
    } catch (error) {
      console.error("Error fetching Vendores", error);
    }
  };

  const handleVendorChange = (event) => {
    setSelectedVendor(event.target.value);
  };

  const handleConfirmVendorChange = async () => {
    if (!selectedVendor) {
      notifyCenter("warning", "Vennligst velg en leverandør", { duration: 3000 });
      return;
    }
    setLoading(true);
    try {
      const orderAddress = orderData?.address;
      // API call to change status
      const response = await changeVendor(orderId, selectedVendor, orderAddress); // Change this to the actual API call
      console.log("changeVendor response", response);
      if (response.status) {
        setOpenVendorModal(false);
        notifyCenter("success", "Leverandør endret vellykket!", { duration: 2000 });
        setLoading(false);
        setTimeout(() => window.location.reload(), 1000);
      } else {
        notifyCenter("error", "Kunne ikke endre leverandør. Vennligst prøv igjen.", { duration: 3000 });
      }
    } catch (error) {
      console.error("Error changing vendor", error);
      notifyCenter("error", "Det oppstod en feil under endring av leverandør.", { duration: 3000 });
      setLoading(false);
    }
  };

  const handleOpenVendorModal = () => {
    setOpenVendorModal(true);
  };

  const handleCloseVendorModal = () => {
    setOpenVendorModal(false);
  };


  const fetchStatuses = async () => {
    try {
      const response = await fetchStatusList();
      console.log("fetching statuses", response);
      if (response.status) {
        // Kun ekte statuser: valget endrer ordren.
        setStatusList(response.status_list.filter((s) => !s.legacy));
      }
    } catch (error) {
      console.error("Error fetching statuses", error);
    }
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleOpenStatusModal = () => {
    setOpenStatusModal(true);
  };

  const handleCloseStatusModal = () => {
    setOpenStatusModal(false);
  };

 
  const [openChangeRequest, setOpenChangeRequest] = useState(false);

  const handleChangeRequest = () => {
    console.log("click change request");
    setOpenChangeRequest(!openChangeRequest);
  };

   useEffect(() => {
    fetchOrderDetails();
    fetchStatuses();
    fetchVendors();
  }, []);

  return (
    <DashboardLayout>
      <Box>

        {!isLoading && (
          <>
            <SoftBox mt={4}>
              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 1000,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={100} color="info" />
                </div>
              )}
              {/*
              <Box sx={{ display: "flex", gap: "10px", justifyContent: "end" }}>

                <Box component={NavLink} to={`/bestillinger/edit-details/${orderId}`}>
                  {role === "admin" && (
                    <SoftButton
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      variant="outlined"
                      color="info"
                      size="small"
                    >
                      <EditIcon fontSize="medium" />
                      <span style={{ padding: "0 6px" }}>Rediger</span>
                    </SoftButton>
                  )}
                </Box>
                <Box component={NavLink} to={`/bestillinger/edit-details/${orderId}`}>
                  {["admin", "vendor"].includes(role) && (
                    <SoftButton
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={handleChangeRequest}
                    >
                      <AutorenewIcon fontSize="medium" />
                      <span style={{ padding: "0 6px" }}>Endringsforespørsel</span>
                    </SoftButton>
                  )}
                </Box>
                <Box component={NavLink} to={`/bestillinger/edit-details/${orderId}`}>
                  {["admin", "vendor", "customer"].includes(role) && (
                    <SoftButton
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                      variant="outlined"
                      color="info"
                      size="small"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                    >
                      <CloseIcon fontSize="medium" />
                      <span style={{ padding: "0 6px" }}>Kanseller forespørsel</span>
                    </SoftButton>
                  )}
                </Box> 

                 <SoftButton variant="outlined" color="secondary" size="small">
                  <EditIcon />
                  <span style={{ padding: "0 6px" }}>Rediger</span>
                </SoftButton> 
              </Box>
              */}
            </SoftBox>

            <SoftBox position="relative" mt={4}>
              {/* <DashboardNavbar absolute dark /> */}
              <SoftBox
                display="flex"
                alignItems="center"
                position="relative"
                minHeight="18.75rem"
                borderRadius="xl"
                sx={{
                  // backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                  //   `${linearGradient(
                  //     rgba(gradients.info.main, 0.6),
                  //     rgba(gradients.info.state, 0.6)
                  //   )},

                  //   url(${curved0})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50%",
                  overflow: "hidden",
                  boxShadow:
                    " rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                }}
              >
                <MyGoogleMap lng={+orderData?.lng} lat={+orderData?.lat} />
              </SoftBox>
              <Card
                sx={{
                  width: "93%",

                  backdropFilter: `saturate(200%) blur(30px)`,
                  background: "rgba(255, 255, 255, 0.6)",

                  boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
                  position: "relative",
                  mt: -8,
                  mx: "auto",
                  py: 2,
                  px: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <SoftAvatar
                      src={homeimage}
                      alt="profile-image"
                      variant="rounded"
                      sx={{
                        width: { xs: 50, sm: 50, md: 50, lg: 50, xl: 53, xxl: 70 },
                        height: { xs: 50, sm: 50, md: 50, lg: 50, xl: 53, xxl: 70 }
                      }}
                      shadow="sm"
                    />
                  </Grid>
                  <Grid item>
                    <SoftBox height="100%" mt={0.5} lineHeight={1}>
                      <SoftTypography variant="h5" fontWeight="medium" color="rgba(0, 0, 0, 0.87)" sx={{ fontSize: { xs: "18px", sm: "18px", md: "18px", xxl:"26px" } }}>
                        Leveringsadresse
                      </SoftTypography>
                      <SoftTypography variant="button" fontWeight="medium" color="rgba(0, 0, 0, 0.87)" sx={{ fontSize: { xs: "16px", sm: "16px", md: "10px", xxl:"16px" } }}>
                        {orderData.address}
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={7.5} lg={7.6} xxl={7} sx={{ display: "inline-grid", justifyContent: "right !important" }}>
                    <AppBar position="static">
                      <Box sx={{ display: "flex",
                        flexWrap: "wrap",
                        gap: "20px", }}>
                        <SoftBox
                          sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            backgroundColor: "#fff",
                            padding: { xs: "8px", sm: "8px", md: "6px", xxl:"8px" },
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            borderRadius: "5px",
                            p: 1,

                            // minWidth: { xs: "auto", sm: "200px" }, width: {
                            //   xs: "auto", sm: "200px"
                            // }
                          }}
                        >
                          <FireTruckIcon sx={{ fontSize: { xs: "26px", sm: "26px", md: "22px", xxl:"26px" }, color: "#FFC312" }} />
                          <SoftTypography color="rgba(0, 0, 0, 0.87)"
                          fontWeight="medium"
                          sx={{ fontSize: { xs: "12px", sm: "12px", md: "10px", xxl:"12px" } }}>
                            Mengde {orderData?.total_volume ? `${orderData.total_volume}m³` : "0m³"}
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            backgroundColor: "#fff",
                            padding: { xs: "8px", sm: "8px", md: "6px", xxl:"8px" },
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            borderRadius: "5px",
                            p: 1,

                            // minWidth: { xs: "auto", sm: "200px" }, width: {
                            //   xs: "auto", sm: "200px"
                            // }
                          }}
                        >
                          <EventIcon sx={{ fontSize: { xs: "26px", sm: "26px", md: "22px", xxl:"26px" }, color: "grey" }} />
                          <SoftTypography 
                            color="rgba(0, 0, 0, 0.87)"
                            fontWeight="medium"
                            sx={{ fontSize: { xs: "12px", sm: "12px", md: "10px", xxl:"12px" } }}
                          >
                            {orderData?.delivery_date?.[0]?.date && orderData?.delivery_date?.[0]?.time 
                                ? `Leveringstid ${orderData.delivery_date[0].date} | Kl. ${orderData.delivery_date[0].time}`
                                : "Levering avtales"}
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                            padding: { xs: "8px", sm: "8px", md: "6px", xxl:"8px" },
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            p: 1,
                            // minWidth: { xs: "auto", sm: "130px" }, width: {
                            //   xs: "auto", sm: "130px"
                            // }
                          }}
                        >
                          <CloudIcon sx={{ fontSize: { xs: "26px", sm: "26px", md: "22px", xxl:"26px" }, color: "#4B7BEC" }} />
                          <SoftTypography color="rgba(0, 0, 0, 0.87)"
                            fontWeight="medium"
                            sx={{ fontSize: { xs: "12px", sm: "12px", md: "10px", xxl:"12px" } }}>
                             Støpeværet {orderData?.weather_temprature ? `${orderData.weather_temprature}` : "0°C"}
                          </SoftTypography>
                        </SoftBox>

                        {/* <Tab disabled sx={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", fontSize: '1rem' }} label={"1300 mm Levernce"} icon={<FireTruckIcon sx={{ color: "info.main", fontSize: "40px" }} />} ></Tab>
                    <Tab disabled sx={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", fontSize: '0.7rem' }} label="Delivery Date 11/2/2024" icon={<LocalShippingIcon sx={{ color: "info.main" }} />} />
                    <Tab disabled sx={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", fontSize: '0.7rem' }} label="Weather 5 C" icon={<CloudIcon sx={{ color: "info.main" ,fontSize: "40px"}} />} />  */}
                      </Box>
                    </AppBar>
                  </Grid>
                </Grid>
              </Card>
            </SoftBox>

            {["admin"].includes(role) && (
              <SoftBox mt={4} mb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12} xl={12}>
                    <Card
                      sx={{
                        borderRadius: "12px",
                        padding: 3,
                        background: "linear-gradient(135deg,#fff, #fff)", // Gradient background
                        color: "white",
                        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                        flexDirection: "column",
                        height: "100%", // Force equal height
                        overflow:"visible"
                      }}
                    >
                      <Grid container spacing={3}>

                        <Grid item xs={12} md={3} xl={3}>
                          <Box ref={dropdownRef} sx={{ position: "relative" }}>
                            <SoftButton
                              variant="gradient"
                              color="dark"
                              fullWidth
                              size="small"
                              sx={{ fontWeight: "bold", fontSize: "14px", padding: "8px" }}
                              onClick={() => setDropdownOpen(!dropdownOpen)}
                            >
                              📩 SEND E-POST MANUELT
                            </SoftButton>

                            {dropdownOpen && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  zIndex: 10,
                                  backgroundColor: "#fff",
                                  boxShadow: 3,
                                  borderRadius: 2,
                                  minWidth: "100%",
                                  mt: 1,
                                }}
                              >
                                {emailTemplates.length > 0 ? (
                                  emailTemplates.map((template, i) => (
                                    <MenuItem
                                      key={template.id || i}
                                      onClick={() => {
                                        setDropdownOpen(false);
                                        // Trigger edit logic here
                                        handleEditTemplate(template.id); // You define this
                                      }}
                                    >
                                      {template.template_name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>Ingen maler funnet</MenuItem>
                                )}
                              </Box>
                            )}
                          </Box>
                        </Grid>



                        <Grid item xs={12} md={3} xl={3}>
                          <SoftButton
                            variant="gradient"
                            color="success"
                            fullWidth
                            size="small"
                            onClick={handleOpenStatusModal}
                            sx={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              padding: "8px",
                            }}
                          >
                            Endre status
                          </SoftButton>
                        </Grid>
                    
                        
                          
                          <Grid item xs={12} md={3} xl={3}>
                            <SoftButton
                              variant="gradient"
                              color="info"
                              fullWidth
                              size="small"
                              onClick={handleOpenVendorModal}
                              sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                padding: "8px",
                              }}
                            >
                              Endre leverandør
                            </SoftButton>
                          </Grid>

                          <Grid item xs={12} md={3} xl={3}>
                            <SoftButton
                              variant="gradient"
                              color="secondary"
                              fullWidth
                              size="small"
                              onClick={handleDownloadPriceAnalysis}
                              sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                padding: "8px",
                              }}
                            >
                              <DownloadIcon sx={{ mr: 1 }} /> Last ned prisanalyse
                            </SoftButton>
                          </Grid>
                      
                      
                          {/*
                            <Grid item xs={12} md={4} xl={4}>
                              <SoftButton
                                variant="gradient"
                                color="error"
                                fullWidth
                                size="small"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  padding: "8px",
                                }}
                              >
                                Kanseller bestilling
                              </SoftButton>
                            </Grid>
                          */}

                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              </SoftBox>
            )}

            <Dialog open={showListModal} onClose={() => setShowListModal(false)} maxWidth="sm" fullWidth>
              <DialogTitle>Rediger e-postmal</DialogTitle>
              {isLoadingTemplates ? (
                <Box display="flex" justifyContent="center" alignItems="center" py={4}>
                  <CircularProgress color="info" />
                  </Box>
                ) : (
                <form onSubmit={handleSubmit}>
                  <DialogContent>
                
                  
                  
                    <Grid container spacing={2}>

                      <Grid item xs={12}>
                        <FormControl sx={{ width: "100%" }}>
                          <Select
                            displayEmpty
                            value={selectedEmailType}
                            onChange={(e) => setSelectedEmailType(e.target.value)}
                            input={<OutlinedInput onClick={handleInputClick5} />}
                            sx={{
                              height: "40px !important",
                              cursor: "pointer",
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <Typography
                                    variant="body1"
                                    style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px", color: "#aab1c3"}}
                                  >
                                    E-posttype
                                  </Typography>
                                );
                              }
                              const selectedItem = emailTypes.find((type) => type.value === selected);
                              return (
                                <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px"}}>
                                  {selectedItem?.full_name}
                                </Typography>
                              );
                            }}
                            inputProps={{ "aria-label": "Send email to" }}
                            ref={selectRef}
                            open={open5}
                            onClose={handleClose}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpen5(!open5);
                            }}
                          >
                            <MenuItem disabled value="">
                              <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal",}}>
                                <em>E-posttype</em>
                              </Typography>
                            </MenuItem>
                            {emailTypes.map((type) => (
                              <MenuItem key={type.value} value={type.value}>
                                <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal" }}>
                                  {type.full_name}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <FormControl sx={{ width: "100%" }}>
                          <Select
                            value={selectedStatus || ''} // Default to empty string if vehicle_id is undefined
                            onChange={handleStatusChange}
                            fullWidth
                            displayEmpty 
                            input={<OutlinedInput onClick={handleInputClick4} />}
                            sx={{
                              height: "40px !important",
                              cursor: "pointer",
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <Typography
                                    variant="body1"
                                    style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px", color: "#aab1c3"}}
                                  >
                                    Ingen statusendring
                                  </Typography>
                                );
                              }
                              const selectedItem = statusList.find((status) => status.value === selected);
                              return (
                                <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px"}}>
                                  {selectedItem?.label}
                                </Typography>
                              );
                            }}
                            
                            ref={selectRef}
                            open={open4}
                            // Uten onClose lukket Esc og klikk utenfor aldri menyen.
                            onClose={() => setOpen4(false)}
                            onClick={(e) => {
                              e.stopPropagation();
                              // Klikk i menyen og på bakgrunnen kommer hit via portalen; de skal
                              // ikke åpne menyen igjen etter at onClose har lukket den.
                              if (e.currentTarget.contains(e.target)) setOpen4((o) => !o);
                            }}
                            
                          >
                            <MenuItem value="">
                              <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal"}}>
                                Ingen statusendring
                              </Typography>
                            </MenuItem>
                            {statusList && statusList.length > 0 ? (
                              statusList.map((status) => (
                                <MenuItem
                                  key={status.value}
                                  value={status.value}
                                  disabled={status.value === orderData?.order_status_key}
                                >
                                  Endre status til: {status.label}
                                  {status.value === orderData?.order_status_key ? " (nåværende)" : ""}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="">Ingen statuser tilgjengelige</MenuItem>  // Fallback when no status is available
                            )}
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* template_name */}
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          placeholder="E-postmalens navn"
                          name="template_name"
                          value={formData.template_name}
                          onChange={handleChange}
                          variant="outlined"
                          InputProps={{
                            sx: {
                              padding: '10px 14px !important', // Adjust padding to ensure text visibility
                              '& input': {
                                width: 'calc(100% - 0px) !important', // Adjust input width to prevent text cutoff
                              }
                            }
                          }}
                        />
                      </Grid>

                      {/* Subject */}
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          placeholder="Emne"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          variant="outlined"
                          InputProps={{
                            sx: {
                              padding: '10px 14px !important', // Adjust padding to ensure text visibility
                              '& input': {
                                width: 'calc(100% - 0px) !important', // Adjust input width to prevent text cutoff
                              }
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="body2" fontWeight="bold" mb={1}>
                          Send e-post til:
                        </Typography>

                        <Grid container spacing={2}>
                          {["admin", "vendor", "customer"].map((role) => {
                            const isSelected = formData.send_to.includes(role);

                            return (
                              <Grid item xs={12} sm={4} key={role}>
                                <Box
                                  onClick={() => handleToggleSendToRole(role)}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: `1.5px solid ${isSelected ? "#1976d2" : "#ccc"}`,
                                    borderRadius: 2,
                                    px: 1.5,
                                    py: 1.2,
                                    cursor: "pointer",
                                    backgroundColor: isSelected ? "#e3f2fd" : "#fff",
                                    transition: "0.2s ease-in-out",
                                    "&:hover": {
                                      backgroundColor: isSelected ? "#bbdefb" : "#f9f9f9",
                                    },
                                  }}
                                >
                                  <Box display="flex" alignItems="center" gap={1}>
                                    <Box
                                      sx={{
                                        backgroundColor: "#1976d2",
                                        color: "#fff",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 30,
                                        height: 30,
                                        fontSize: 18,
                                      }}
                                    >
                                      {roleIcons[role]}
                                    </Box>
                                    <Typography fontWeight="bold" variant="body2">
                                      {role.charAt(0).toUpperCase() + role.slice(1)}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: 22,
                                      height: 22,
                                      borderRadius: "6px",
                                      border: "2px solid #ccc",
                                      backgroundColor: isSelected ? "#1e293b" : "#fff",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#fff",
                                    }}
                                  >
                                    {isSelected && <Check fontSize="small" sx={{ fontSize: 14 }} />}
                                  </Box>
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                      {/* send_to_email */}
                      <Grid item xs={12}>
                        
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          placeholder="Send e-post til (kommaseparert)"
                          name="send_to_email"
                          value={formData.send_to_email || ""}
                          onChange={handleSendToEmailChange}
                          onBlur={handleSendToEmailBlur}
                          variant="outlined"
                          required
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              width: "100%",
                              boxSizing: "border-box",
                              padding: "10px 14px",
                              alignItems: "stretch",
                            },
                            "& .MuiInputBase-inputMultiline": {
                              width: "100% !important",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                            },
                          }}
                        />

                        <Typography variant="caption" sx={{ display: "block", mb: 1, mt: 1, color: "#6b7280" }}>
                          Velg Admin/Vendor/Customer for automatisk e-post. Du kan også legge til flere e-poster manuelt (kommaseparert).
                        </Typography>

                      </Grid>


                      <Grid item xs={12}>
                        <Box mb={2} p={2} sx={{ backgroundColor: "#f4f6f8", borderRadius: "8px" }}>
                          <Typography variant="body2" fontWeight="bold" mb={1}>
                            Tilgjengelige variabler (kopier og lim inn i meldingen):
                          </Typography>
                          <Typography variant="body2" sx={{ wordBreak: "break-word", fontFamily: "monospace" }}>
                            {'{{customer_name}}, {{vendor_name}}, {{project_link_customer}}, {{project_link_vendor}}, {{order_invoice}}, {{order_payment_link}}, {{order_payment_button}}, {{delivery_day}}, {{delivery_date}}, {{delivery_time}}, {{customer_phone_number}}, {{admin_phone_number}}, {{volume}}, {{concrete_quality}}, {{truck_type}}, {{delivery_address}}'}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Message */}
                      <Grid item xs={12}>
                        <ReactQuill
                          theme="snow"
                          value={formData.message}
                          onChange={(value) =>
                            setFormData((prev) => ({ ...prev, message: value }))
                          }
                          style={{
                            borderRadius: '12px',
                            backgroundColor: '#fff',
                          }}
                          placeholder="Skriv meldingen din her..."
                        />
                      </Grid>
                    </Grid>
                  
                
                  </DialogContent>
                  <DialogActions>
                    <SoftButton onClick={() => setShowListModal(false)} variant="outlined" color="error">
                      Lukk
                    </SoftButton>
                    <SoftButton variant="gradient" color="info" type="submit">
                      Send
                    </SoftButton>
                  </DialogActions>
                </form>
              )}
            </Dialog>

            {/* Samme dialog som ordresidene. Den gamle modalen her endret status
                direkte, uten å vise e-posten først, og regelen sendte den ut
                uten at admin fikk se eller stoppe den. */}
            <StatusChangeDialog
              open={openStatusModal}
              orderId={orderId}
              currentStatus={orderData?.order_status_key || ""}
              onClose={handleCloseStatusModal}
              onChanged={fetchOrderDetails}
            />

            <Dialog open={openVendorModal} onClose={handleCloseVendorModal} maxWidth="sm" fullWidth>
              <DialogTitle>Velg leverandør</DialogTitle>
              <DialogContent>
                {/* Add a label above the dropdown */}
                
               
                <Select
                  value={selectedVendor || ''} 
                  onChange={handleVendorChange}
                  fullWidth
                  displayEmpty
                  input={<OutlinedInput onClick={handleInputClick2} />}
                  sx={{
                    height: "40px !important",
                    cursor: "pointer",
                  }}
                  
                  ref={selectRef}
                  open={open2}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen2(!open2);
                  }} 
                  
                >
                  {/* Placeholder Option */}
                  <MenuItem value="" disabled>
                    Velg leverandørtype
                  </MenuItem>
                  {/* Vehicle Type Options */}
                  {vendorList && vendorList.length > 0 ? (
                    vendorList.map((vendor) => (
                      <MenuItem key={vendor.id} value={vendor.id}>
                        {vendor.title}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="">Ingen leverandører tilgjengelige</MenuItem>  // Fallback when no vendor is available
                  )}
                </Select>
            
              </DialogContent>
              <DialogActions sx={{ margin: 1 }}>
                <SoftButton onClick={handleCloseVendorModal} variant="outlined" color="error">Lukk</SoftButton>
                <SoftButton onClick={handleConfirmVendorChange} variant="gradient" color="info">Lagre</SoftButton>
              </DialogActions>
              
            </Dialog>
            
            <SoftBox mt={4} mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} xl={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      padding: 3,
                      background: "linear-gradient(135deg,#bbd2c5, #536976)", // Gradient background
                      color: "white",
                      boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                      flexDirection: "column",
                      height: "100%", // Force equal height
                    }}
                  >
                    {/* Title */}
                    <SoftTypography
                      variant="h5"
                      fontWeight="bold"
                      mb={3}
                      color="white"
                      textAlign="left"
                    >
                      Kundeinformasjon
                    </SoftTypography>

                    {/* Content */}
                    <Grid container spacing={1} alignItems="center">
                      {/* Name */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <AccountCircleIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.fullname}
                        </SoftTypography>
                      </Grid>

                      {/* Phone */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <PhoneIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.phone ? orderData.phone : "N/A"}
                        </SoftTypography>
                      </Grid>

                      {/* Email */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <EmailIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.email ? orderData.email : "N/A"}
                        </SoftTypography>
                      </Grid>

                      {/* Address */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <LocationOnIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.address}
                        </SoftTypography>
                      </Grid>
                      
                    </Grid>
                  </Card>
                </Grid>
                {/* 2nd Box: Prosecutor Information */}
                <Grid item xs={12} md={12} xl={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      padding: 3,
                      background: "linear-gradient(135deg, #4cb8c4, #3cd3ad)", // Gradient Background
                      color: "white",
                      boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                      height: "100%",
                    }}
                  >
                    {/* Title */}
                    <SoftTypography
                      variant="h5"
                      fontWeight="bold"
                      mb={3}
                      color="white"
                      textAlign="left"
                    >
                      Leverandørinformasjon
                    </SoftTypography>

                    {/* Content */}
                    <Grid container spacing={1} alignItems="center">
                      {/* Name */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <AccountCircleIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.vendor_title}
                        </SoftTypography>
                      </Grid>

                      {/* Email */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <EmailIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.vendor_email}
                        </SoftTypography>
                      </Grid>

                      {/* Location */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <LocationOnIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.vendor_address}
                        </SoftTypography>
                      </Grid>

                      {/* Distance */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <DistanceIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {Number(orderData?.distance).toLocaleString('no-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} km
                        </SoftTypography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                {/* 3rd Box: Project Details */}
                <Grid item xs={12} xl={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      padding: 3,
                      background: "linear-gradient(135deg, #B0C4DE, #6A85B6)", // Gradient Background
                      color: "white",
                      boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    {/* Title */}
                    <SoftTypography
                      variant="h5"
                      fontWeight="bold"
                      mb={3}
                      color="white"
                      textAlign="left"
                    >
                      Prosjektdetaljer
                    </SoftTypography>

                    {/* Content */}
                    <Grid container spacing={1} alignItems="center">
                      {/* Order Title */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <WorkIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.order_title}
                        </SoftTypography>
                      </Grid>

                      {/* Created Date */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <EventIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.created_date?.date?.split(" ")[0] || "N/A"}
                        </SoftTypography>
                      </Grid>

                      {/* Status */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <VerifiedIcon sx={{ fontSize: 20, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10} display="flex" alignItems="center">
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{
                            fontSize: "12px",            
                            backgroundColor: "#4CAF50",  
                            color: "#fff",             
                            fontWeight: "medium",
                            padding: "2px 8px",          
                            borderRadius: "10px",        
                            textAlign: "center",
                            display: "inline-block",  
                          }}
                        >
                          {orderData?.order_status?.status_text}
                        </SoftTypography>
                      </Grid>

                      {/* Description */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <DescriptionIcon sx={{ fontSize: 24, color: "#fff" }} />
                      </Grid>
                      <Grid item xs={10}>
                        <SoftTypography
                          variant="body2"
                          fontWeight="medium"
                          sx={{ fontSize: "14px", color: "#fff" }}
                        >
                          {orderData?.order_status?.status_description}
                        </SoftTypography>
                      </Grid>

                      {/* Order Total */}
                      <Grid item xs={2} display="flex" justifyContent="center">
                        <LocalAtmIcon sx={{ fontSize: 24, color: "#fff" }} /> {/* Money Icon */}
                      </Grid>
                      <Grid item xs={10}>
                        {role === "admin" && !isEditing ? (
                          <>
                            <SoftBox display="flex" justifyContent="start" alignItems="center" gap="10px">
                              <SoftTypography variant="body2" fontWeight="medium" sx={{ fontSize: "14px", color: "#fff" }}>
                                kr {orderData?.order_total || 0}
                              </SoftTypography>
                              <SoftButton
                                onClick={handleEditClick}
                                variant="outlined"
                                size="small"
                                sx={{
                                  backgroundColor: "#fff", // White background
                                  color: "rgba(0, 0, 0, 0.87)", // Black text color
                                  padding: "0px 0px",
                                  minWidth: "45px", // Corrected camelCase for min-width
                                  minHeight: "25px", // Corrected camelCase for min-width
                                  "&:hover": {
                                    backgroundColor: "#fff", // Slightly darker shade on hover
                                  },
                                }}
                              >
                                <EditIcon sx={{ fontSize: "24px" }} /> {/* Corrected icon font size */}
                              </SoftButton>
                            </SoftBox>

                            {/* Modal for editing the order total */}
                            <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                              <DialogTitle>Oppdater bestillingens totalbelø</DialogTitle>
                              <DialogContent>
                                <TextField
                                  type="text"
                                  value={tempOrderTotal}
                                  onChange={(e) => setTempOrderTotal(e.target.value)}
                                  fullWidth
                                />
                              </DialogContent>
                              <DialogActions sx={{ justifyContent: "flex-end", gap: "5px", paddingRight: "20px" }}>
                                <SoftButton
                                  onClick={() => {
                                    setTempOrderTotal(orderData?.order_total || 0); // Reset the value
                                    setIsModalOpen(false); // Close the modal
                                  }}
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  sx={{ padding: "0px", fontSize: "10px" }}
                                >
                                  Avbryt
                                </SoftButton>
                                <SoftButton
                                  onClick={() => {
                                    handleSaveClick(); // Save the updated total
                                    setIsModalOpen(false); // Close the modal
                                  }}
                                  variant="gradient"
                                  color="info"
                                  size="small"
                                  sx={{ padding: "0px", fontSize: "10px" }}
                                >
                                  Lagre
                                </SoftButton>
                                
                              </DialogActions>
                            </Dialog>
                          </>
                        ) :  (
                          <SoftTypography variant="body2" fontWeight="medium" sx={{ fontSize: "14px", color: "#fff" }}>
                            kr {orderData?.order_total || 0}
                          </SoftTypography>
                        )}
                      </Grid>

                    </Grid>
                  </Card>
                </Grid>
              


              </Grid>
            </SoftBox>
            {orderData?.deliveries?.length >= 0 && (
              <EditProjectAccordion 
                data={orderData?.deliveries} 
                orderNumber={orderId}  
                onSave={handleSave} // Pass onSave as a prop
              />
            )}


            {orderData?.attached_images?.length > 0 && (
              <SoftBox mt={4} mb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12} xl={12}>
                    <Card
                      sx={{
                        borderRadius: "12px",
                        padding: 3,
                        background: "#fff",
                        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <SoftTypography variant="h6" mb={1} px={1}>
                        Uploaded Files
                      </SoftTypography>

                      {orderData.attached_images.map((file, index) => (
                        <Box
                          key={file.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "#fff",
                            padding: "10px 16px",
                            borderRadius: "8px",
                            boxShadow: 4,
                            mb: 1,
                          }}
                        >
                          <Box display="flex" alignItems="center">
                            <FileIcon sx={{ fontSize: 24, color: "#1976D2",  mr: 1 ,ml: 1}} />
                            <SoftTypography variant="body1" sx={{ fontSize: 14, color: "#344767"}}>{file.originalName}</SoftTypography>
                          </Box>

                          <IconButton component="a" target="_blank" href={file.url} download sx={{ color: "green" }}>
                            <DownloadIcon />
                          </IconButton>
                        </Box>
                      ))}
                    </Card>
                  </Grid>
                </Grid>
              </SoftBox>
            )}

          </>
        )}
        <CancelRequest modalVisble={openChangeRequest} setModalVisble={setOpenChangeRequest} />
      </Box>
    </DashboardLayout>
  );
}

export default EditDetail;
